import "./App.css";
import Contact from "./ContactForm";
import Navbar from "./Navbar";
import pic from "./images/Untitled-1.jpg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFacebook,
  faTiktok,
  faInstagram,
  faWhatsapp,
} from "@fortawesome/free-brands-svg-icons";

function App() {
  const phoneNumber = "789642720";
  const message = encodeURIComponent(
    "Hello Auratek Digitals, I am visiting from your official site.\nCan we discuss business?",
  );
  const whatsappUrl = `http://wa.me/${phoneNumber}?text=${message}`;

  const openFacebookpage = (e) => {
    e.preventDefault();

    const pageId = "61590919545521";
    const pageName = "AuratekDigitals";

    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

    if (isMobile) {
      const appUrl = navigator.userAgent.match(/iPhone|iPad|iPod/i)
        ? `fb://profile/${pageId}`
        : `fb://profile/${pageId}`;
      window.location.href = appUrl;

      setTimeout(() => {
        window.location.href = `https://facebook.com/${pageName}`;
      }, 500);
    } else {
      window.open(
        `https://facebook.com/${pageName}`,
        "_blank",
        "noopener,noreferrer",
      );
    }
  };

  return (
    <div className="web-page">
      <Navbar />
      <section className="hero-section" id="about">
        <div className="hero-description">
          <h2>
            Transforming Ideas Into <br />
            Powerful Digital Solutions
          </h2>
          <p>
            Auratek Digitals helps business establish a strong digital presence
            through powerful graphic design, modern websites and innovative
            software solutions.
          </p>
          <a href="#contact" className="button">
            Contact us
          </a>
        </div>

        <div className="hero-image">
          <img src={pic} alt="" />
        </div>
      </section>

      <section className="our-services" id="services">
        <h2>Our services</h2>
        <p>
          We provide innovative digital solution that help business build their
          brand and grow online.
        </p>

        <div className="service-cards">
          <div className="service-card">
            <h3>Graphic Design</h3>
            <p>
              Build a memorable brand with professionally designed logos,
              flyers, posters, business cards, brochures, social media graphics,
              and more.
            </p>
          </div>

          <div className="service-card">
            <h3>Website Development</h3>
            <p>
              We design fast, responsive, and modern websites that help
              businesses showcase their services, attract customers, and grow
              online.
            </p>
          </div>

          <div className="service-card">
            <h3>Software Solutions</h3>
            <p>
              We develop custom software solutions that simplify business
              operations and improve efficiency. (Launching Soon.)
            </p>
          </div>
        </div>
      </section>

      <section className="why-us">
        <h2>Why choose Auratek Digitals</h2>

        <p>
          We are committed to delivering high-quality digital solutions that
          help businesses succeed in today's digital world.
        </p>

        <div className="cards">
          <div className="service-cards">
            <h3>⚡ Fast Turnaround</h3>
            <p>
              We value your time and deliver projects efficiently without
              compromising on quality.
            </p>
          </div>
          <div className="service-cards">
            <h3>🤝 Reliable Support</h3>
            <p>
              We stay connected throughout your project and provide dependable
              support whenever you need assistance.
            </p>
          </div>
          <div className="service-cards">
            <h3>💡 Innovative Solutions</h3>
            <p>
              Every business is unique, so we create tailored solutions that
              match your goals and vision.
            </p>
          </div>
          <div className="service-cards">
            <h3>🎯 Attention to Detail</h3>
            <p>
              We focus on the small details that make your brand and digital
              presence look professional.
            </p>
          </div>
          <div className="service-cards">
            <h3>💰 Affordable Pricing</h3>
            <p>
              High-quality digital services at prices that suit startups,
              entrepreneurs, and growing businesses.
            </p>
          </div>
          <div className="service-cards">
            <h3>📈 Growth-Focused</h3>
            <p>
              We don't just build designs and websites—we create solutions that
              help your business grow.
            </p>
          </div>
        </div>
      </section>

      <section className="how-it-works">
        <h2>How it works</h2>
        <p>
          From your first idea to the final product, we make the process simple,
          transparent, and efficient.
        </p>
        <div className="cards">
          <div className="service-cards">
            <h3>📞 Get in Touch</h3>
            <p>
              Reach out through our contact form, WhatsApp, email, or social
              media and tell us about your project.
            </p>
          </div>
          <div className="service-cards">
            <h3>💬 Discuss Your Project</h3>
            <p>
              We'll understand your goals, discuss your requirements, and
              recommend the best solution for your business.
            </p>
          </div>
          <div className="service-cards">
            <h3>🛠️ We Bring Your Vision to Life</h3>
            <p>
              Our team designs, develops, and refines your project while keeping
              you updated on the progress.
            </p>
          </div>

          <div className="service-cards">
            <h3>🚀 Launch & Ongoing Support</h3>
            <p>
              Receive your completed project along with guidance and support to
              help you get the most from it.
            </p>
          </div>
        </div>
      </section>

      <section className="our-contact" id="contact">
        <h2>Let's work together</h2>
        <p>
          Have a project in mind? We'd love to hear from you. Fill out the form
          or contact us directly.
        </p>
        <div className="contact">
          <div className="contact-info">
            <h3>Contact information</h3>
            <ul>
              <li>📞 +263 78 964 2720 | +263 78 740 8440</li>
              <li>✉ auratekdigitals@gmail.com</li>
              <li>📍 Harare, Zimbabwe</li>
              <li>🌐 @AuratekDigitals</li>
            </ul>
          </div>

          <div className="contact-form">
            <h3>Contact form</h3>
            <Contact />
          </div>
        </div>
      </section>
      <footer>
        <div className="info">
          <div className="logo">
            <h3>Auratek Digitals</h3>
            <ul>
              <li>
                <a href="/">About us</a>
              </li>
              <li>
                <a href="#services">Mission</a>
              </li>
              <li>
                <a href="/">Vision</a>
              </li>
            </ul>
          </div>

          <div className="quick-links">
            <h3>Quick Links</h3>
            <ul>
              <li>
                <a href="/">Home</a>
              </li>
              <li>
                <a href="/">About</a>
              </li>
            </ul>
          </div>

          <div className="services">
            <h3>Services</h3>
            <ul>
              <li>Graphic Design</li>
              <li>Website Development</li>
              <li>Software Solutions</li>
            </ul>
          </div>

          <div className="contact">
            <h3>Contact</h3>
            <ul>
              <li>+263 78 964 2720 | +263 78 740 8440</li>
              <li>auratekdigitals@gmail.com</li>
              <li>Harare, Zimbabwe</li>
            </ul>
          </div>
        </div>
        <div className="socials">
          <a href={whatsappUrl} target="blank">
            <FontAwesomeIcon icon={faWhatsapp} size="2x" />
          </a>
          <p onClick={openFacebookpage}>
            <FontAwesomeIcon icon={faFacebook} size="2x" />
          </p>
          <p>
            <a
              href="https://www.instagram.com/auratekdigitals/"
              rel="noopener noreferrer"
              aria-label="Instagram"
            >
              <FontAwesomeIcon icon={faInstagram} size="2x" />
            </a>
          </p>
          <p>
            <a
              href="https://www.tiktok.com/@auratekdigitals"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="TikTok"
            >
              <FontAwesomeIcon icon={faTiktok} size="2x" />
            </a>
          </p>
        </div>
        <div className="copy">
          © 2026 Auratek Digitals. All Rights Reserved.
        </div>
      </footer>
    </div>
  );
}

export default App;
